module.exports = __webpack_public_path__ + "static/img/pic.e310f3df.png";